import { useEffect, useState } from "react";
import { ImageIcon, ImageOff, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

/**
 * AuthImage — fetches a protected object via the API (with auth) and renders it.
 * kind: "selfie" | "lampiran"
 */
export function AuthImage({ path, kind = "selfie", alt = "", className = "", testId, onClick }) {
  const [state, setState] = useState({ loading: true, url: null, error: false });

  useEffect(() => {
    let alive = true;
    let objectUrl = null;
    if (!path) {
      setState({ loading: false, url: null, error: true });
      return () => {};
    }
    (async () => {
      try {
        const url = kind === "biodata" ? `/biodata/file/${path}` : `/files/${kind}/${path}`;
        const resp = await api.get(url, { responseType: "blob" });
        objectUrl = URL.createObjectURL(resp.data);
        if (alive) setState({ loading: false, url: objectUrl, error: false });
      } catch {
        if (alive) setState({ loading: false, url: null, error: true });
      }
    })();
    return () => {
      alive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path, kind]);

  if (!path || state.error) {
    return (
      <div
        className={`flex flex-col items-center justify-center gap-1 bg-slate-50 border border-slate-200 border-dashed rounded-md text-slate-400 ${className}`}
        data-testid={testId ? `${testId}-empty` : undefined}
      >
        <ImageOff size={20} />
        <span className="text-[10px] font-semibold">Foto tidak tersedia</span>
      </div>
    );
  }
  if (state.loading) {
    return (
      <div
        className={`flex items-center justify-center bg-slate-50 border border-slate-200 rounded-md text-slate-400 ${className}`}
      >
        <Loader2 size={18} className="animate-spin" />
      </div>
    );
  }
  return (
    <img
      src={state.url}
      alt={alt}
      onClick={onClick}
      data-testid={testId}
      className={`object-cover cursor-zoom-in transition hover:opacity-90 ${className}`}
    />
  );
}

export default AuthImage;

// Named tag for future extensions (e.g., video previews)
export const AuthImageIcon = ImageIcon;
